import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import type { AnimatedIconProps } from '../../primitives/types.js';

export function IcnChevron(props: AnimatedIconProps): ReactNode {
  const { active = false, ...rest } = props;
  return (
    <Svg {...rest} iconName="chevron" data-open={active ? 'true' : 'false'}>
      <path d="M6 4l4 4-4 4" />
    </Svg>
  );
}
